<template>
  <basic-card class="global-basic-card" padding hideHeader :hasMore="showMore">
    <avue-crud
      class="global-table"
      :option="option"
      :data="data"
      :page="page"
      v-model="form"
      v-model:search="search"
      :table-loading="scopeLoading"
      ref="crud"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button>
          </div>
          <div class="global-flex-center">
            
            
          </div>
        </div>
      </template>
      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <comp-button
            v-if="permissionObj.delete"
            type="delete"
            plain
            @click="handleDelete"
            >{{ Lang.btn.delete }}
          </comp-button>
          <comp-button
              v-if="permissionObj.add"
              type="primary"
              icon="icon-add"
              @click.stop="handleAdd()"
              >{{ Lang.btn.addNew }}
            </comp-button>
        </div>
      </template>
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="view" :authorize="true" @click="handleView(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="edit" @click="handleEdit(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click="handleDel(scope.row)" > </CompIconButton>
        </div>
      </template>
      <template #scopeType="{ row }">
        <el-tag>{{ row.scopeTypeName }}</el-tag>
      </template>
    </avue-crud>
  </basic-card>
</template>

<script>
import {
  countryCodeSave,
  countryCodeRemove,
  countryCodeUpdate,
  getCountryCodePage,
  getCountryCodeDetail,
} from '@/api/system/user';
import { mapGetters } from 'vuex';
import { filterDollarKeys } from '@/utils/util';

export default {
  data() {
    return {
      tableKey: 0,
      form: {
        id: ''
        // i18ns: [],
      },
      selectionList: [],
      query: {},
      search: {},
      loading: true,
      showMore: true,
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      drawerVisible: false,
      direction: 'rtl',
      scopeLoading: false,
      scopeMenuId: 0,
      scopeMenuName: this.Lang.label.menu,
      menu: true,
      data: [],
      selectionList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        tip: false,
        searchShow: true,
        searchSpan: 4,
        searchMenuSpan: 6,
        border: true,
        index: true,
        emptyBtn: false,
        searchBtn: false,
        border: false, // 关键
        menuWidth: 146, // 操作列宽
        addBtn: true, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        selection: true,
        menuWidth: 116,
        dialogWidth: 900,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        dialogClickModal: false,
        labelPosition: 'top',
        gutter: 12,
        column: [
          {
            label: this.Lang.label.enName,
            prop: 'englishName',
            search: true,
            align: 'center',
            editDisplay: true,
            addDisplay: true,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputDictEnName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.areaCode,
            prop: 'countryCode',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.areaCode,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.language,
            prop: 'languageType',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.label.language,
                trigger: 'blur',
              },
            ],
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
  },
  methods: {
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.option.selection = this.showMore;
      this.tableKey += 1;
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search)
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义添加
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    rowSave(row, done, loading) {
      countryCodeSave(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      countryCodeUpdate(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return countryCodeRemove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return countryCodeRemove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getCountryCodeDetail({id: this.form.id}).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page, params = {}) {
      this.scopeLoading = true;
      const values = {
        ...params,
      };
      getCountryCodePage(page.currentPage, page.pageSize, Object.assign(values, this.query)).then(
        res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.selectionList = [];
          this.scopeLoading = false;
        }
      );
    },
  },
};
</script>
